/*
 * @Description:【业务工具函数】字段公式计算的派发处理：兼容应用新增、应用详情、审批流程详情
 */

import { isEmpty } from '@/utils/is'

/**
 * @description: 字段公式计算的派发处理
 * @param equationList 需要进行公式计算的字段数据列表
 * @param changField 需要进行公式计算的目标字段
 * @param changeVal 进行公式计算的目标字段数据值
 * @param componentList 相关组件数据
 */
export function formulaEmitter(
  equationList: Recordable[],
  changField: Recordable,
  changeVal: Recordable,
  componentList?: Recordable
) {
  equationList?.forEach((field: Recordable) => {
    const reg = /\{(\w+)\}/
    const { setting, fieldSerial } = field.columnInfo
    const settingData = getFieldFormulaConfig(setting)
    const equalFunc = (Fn?: Fn) => {
      if (settingData.web?.equation) {
        settingData.web.equation.replace(new RegExp(reg, 'g'), (replacer: Recordable) => {
          const match = replacer?.match(new RegExp(reg))
          match && Fn && Fn(match)
        })
      }
    }

    // 公式计算相关字段的fieldSerial数组
    let equalAsoArr: string[] = []
    equalFunc(match => match[1] && equalAsoArr.push(match[1]))
    equalAsoArr = [...new Set(equalAsoArr)]

    // 公式计算涉及的字段，有处于隐藏状态的情况
    const hasHidden =
      componentList &&
      equalAsoArr.some(item => {
        const res = componentList.find(
          (item2: { fieldSerial: string }) => item2.fieldSerial === item
        )
        // 有该字段并且该字段隐藏
        if (res) {
          return !res?.show
        } else {
          return false
        }
      })

    // 派发公式计算事件
    equalFunc(match => {
      if (changField.fieldSerial === match[1] && !hasHidden) {
        changField.renderConfig.equationEmitter.emit(
          `equation_${fieldSerial}`,
          changField,
          changeVal
        )
      }
    })
  })
}

/**
 * @description: 获取字段的公式计算配置数据
 * @param config 字段的公式计算配置数据
 */
export function getFieldFormulaConfig(config: string) {
  return config ? (isEmpty(JSON.parse(config)) ? { web: {} } : JSON.parse(config)) : { web: {} }
}
